import React from 'react';
import { FaTools, FaPalette, FaHandsHelping } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Careers = () => {
  return (
    <div className="min-h-screen pt-16 bg-gradient-to-br from-gold-primary/90 to-gold-secondary/90">
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-8 text-center text-black">Join Our Team</h1>
        
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Introduction */}
          <div className="bg-gold-white p-8 rounded-lg shadow-lg border border-gold-secondary/20">
            <p className="text-lg text-gold-secondary leading-relaxed text-center">
              We're always looking for talented individuals who are passionate about design and craftsmanship. 
              If you're ready to be a part of our growing team, drop us a message.
            </p>
          </div>

          {/* Current Openings */}
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg shadow-lg border border-gold-secondary/20">
            <h2 className="text-2xl font-semibold mb-8 text-center text-black">Current Openings</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="group bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border border-gold-secondary/20 hover:border-gold-primary/30">
                <div className="flex flex-col items-center text-center">
                  <FaTools className="text-4xl mb-4 text-gold-primary group-hover:scale-110 transition-transform duration-300" />
                  <h3 className="text-xl font-semibold mb-2 text-gold-primary">Carpenters</h3>
                  <p className="text-gold-secondary">Skilled woodworkers for custom doors and interiors</p>
                </div>
              </div>

              <div className="group bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border border-gold-secondary/20 hover:border-gold-primary/30">
                <div className="flex flex-col items-center text-center">
                  <FaPalette className="text-4xl mb-4 text-gold-primary group-hover:scale-110 transition-transform duration-300" />
                  <h3 className="text-xl font-semibold mb-2 text-gold-primary">Designers</h3>
                  <p className="text-gold-secondary">Interior designers with creative and technical skills</p>
                </div>
              </div>

              <div className="group bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border border-gold-secondary/20 hover:border-gold-primary/30">
                <div className="flex flex-col items-center text-center">
                  <FaHandsHelping className="text-4xl mb-4 text-gold-primary group-hover:scale-110 transition-transform duration-300" />
                  <h3 className="text-xl font-semibold mb-2 text-gold-primary">Helper Boys</h3>
                  <p className="text-gold-secondary">Assist with installations and material handling</p>
                </div>
              </div>
            </div>
          </div>

          {/* How to Apply */}
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg shadow-lg border border-gold-secondary/20">
            <h2 className="text-2xl font-semibold mb-6 text-center text-black">How to Apply</h2>
            <div className="text-center">
              <p className="text-lg text-gold-secondary mb-4">
                Send your resume or inquiry to our phone number{' '}
                <a 
                  href="tel:+919340011444" 
                  className="text-gold-primary font-medium hover:text-gold-secondary transition-colors border-b border-gold-primary hover:border-gold-secondary"
                >
                  +91 9340011444
                </a>
                {' '}or use our{' '}
                <Link 
                  to="/contact" 
                  className="text-gold-primary font-medium hover:text-gold-secondary transition-colors border-b border-gold-primary hover:border-gold-secondary"
                >
                  Contact Form
                </Link>
                {' '}with the subject "Career Application".
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
